import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findUserHistories = (headers, params) => {
    let query = buildQuery(params, []);
    if (params?.filters?.userName?.value) {
        query += `&userName=${params.filters.userName.value?.trim()}`;
    }
    if (params?.filters?.toDate?.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    if (params?.filters?.fromDate?.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params?.filters?.phoneNumber?.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value?.trim()}`;
    }
    if (params?.filters?.email?.value) {
        query += `&email=${params.filters.email.value?.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/user-histories/history${query}`, {
        headers,
    });
};

export const getDetailInUserHistory = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/user-histories/${id}/detail`, {
        headers,
    });
};
